<template>
  <div class="page">
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      finished-text=""
      @load="onLoad"
    >
      <div class="list-box">
        <SeoLink
          class="list-bd"
          v-for="(item, index) in lists"
          :key="index"
          :to="detailRoute(item.qid)"
        >
          <div class="list-right">
            <div class="list-text">{{ item.title }}</div>
            <div class="list-count">
              <label>{{ item.joined }}</label
              >人已答题
            </div>
          </div>
          <div class="list-icon-bd">
            <img class="list-icon" :src="item.banner" mode="aspectFill" />
            <img
              class="practice-icon"
              :src="practice_icon"
              v-if="item.temp == 1"
            />
            <img
              class="practice-icon"
              :src="practice_daily_icon"
              v-if="item.temp == 2"
            />
            <img
              class="practice-icon"
              :src="question_icon"
              v-if="item.temp == 3"
            />
            <img
              class="practice-icon"
              :src="award_icon"
              v-if="item.temp == 4"
            />
          </div>
        </SeoLink>
      </div>
    </van-list>
  </div>
</template>
<script>
import SeoLink from "@/components/SeoLink.vue";
import questionOnly from "@/utils/questionOnly";
import { reLogin, getToken, deepClone } from "@/utils/common";
import { Toast } from "vant";
import {
  practice_icon,
  practice_daily_icon,
  question_icon,
  award_icon
} from "@/utils/config";
export default {
  components: { SeoLink },
  data() {
    return {
      loading: false,
      finished: true,
      lists: [],
      practice_icon,
      practice_daily_icon,
      question_icon,
      award_icon,
      count: 10,
      page: 1
    };
  },
  methods: {
    detailRoute(qid) {
      return {
        name: "normalDetail",
        query: { qid: qid }
      };
    },
    onLoad() {
      this.getLists(this.page + 1);
    },
    getLists(page = 1) {
      this.page = page;
      let param = {
        type: 3,
        access_token: getToken(),
        count: this.count,
        page: this.page,
        category: this.id
      };
      questionOnly.get("/xcx/ques/v1/list", param).then(res => {
        this.loading = false;
        if (res.sta == 0) {
          if (!res.data.length) {
            this.finished = true;
          } else {
            this.finished = false;
            let curList = deepClone(this.lists);
            this.lists = curList.concat(res.data);
          }
        } else if (res.sta == -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getLists();
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}

.page {
  background-color: #fff;
  height: auto;
}
.list-box {
  margin: 0 rem(30);
  padding-top: rem(30);
}
.list-title {
  font-size: rem(34);
  font-weight: 900;
  padding: rem(20) 0 rem(40);
  color: #333;
}
.list-bd {
  position: relative;
  display: flex;
  margin-bottom: rem(40);
  cursor: pointer;
}
.list-bd .list-icon {
  display: block;
  width: rem(240);
  height: rem(136);
  object-fit: cover;
  border-radius: rem(10);
}
.list-icon-bd {
  position: relative;
}
.list-right {
  flex: 1;
  margin-right: rem(20);
  display: flex;
  flex-direction: column;
  height: rem(140);
  justify-content: space-between;
}
.list-text {
  font-size: rem(32);
  color: #000;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: rem(420);
}
.list-count {
  font-size: rem(24);
  color: #999;
}

.practice-icon {
  position: absolute;
  left: 0;
  top: rem(10);
  width: rem(103);
  height: rem(41);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/category.vue